export default __webpack_public_path__ + "static/media/mysql.cdd30395.png";